module.exports = __webpack_public_path__ + "img/icon-approve-white.ffbb765a.svg";